import { Progress, Text, Group, Paper, ThemeIcon, Stack } from '@mantine/core';
import classes from './OverviewCard.module.css';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';

interface OverviewCardProps {
  title: string;
  description: string;
  outOfText: string;
  filterId?: string;
  percentage: number;
  totalFilteredItems: number;
  totalItems: number;
  icon: ReactJSXElement;
  isActiveFilter: boolean;
  onCardClick?: (filterId: any) => void;
}

export function OverviewCard({
  title,
  description,
  outOfText,
  filterId,
  percentage,
  totalFilteredItems,
  totalItems,
  icon,
  isActiveFilter,
  onCardClick
}: OverviewCardProps) {
  const formattedPercentage = Number(percentage.toFixed(2));

  return (
    <Paper
      style={{ flex: '1 1 180px', minWidth: 180, maxWidth: 280 }}
      radius="md"
      withBorder
      bg={isActiveFilter ? 'rgb(248,248,255)' : undefined}
      className={classes.card}
      onClick={() => {
        if (onCardClick) {
          onCardClick(filterId);
        }
      }}>
      <Group wrap="nowrap" gap="sm" style={{ height: '100%' }}>
        <ThemeIcon className={classes.icon} size={40} radius={40} color={'#3c2f97'}>
          {icon}
        </ThemeIcon>

        <Stack gap={4} justify="space-between" style={{ flex: 1, minWidth: 0, height: '100%' }}>
          <Text fw={700} fz="xs" className={classes.title} lineClamp={2}>
            {title}
          </Text>

          <div>
            <Group justify="space-between" gap={4}>
              <Text fz="xs" c="dimmed">
                {totalFilteredItems} / {totalItems} {outOfText}
              </Text>
              <Text fz="xs" c="dimmed">
                {formattedPercentage}%
              </Text>
            </Group>

            <Progress.Root size="sm" mt={4}>
              <Progress.Section value={formattedPercentage} color="#bf1e2d">
                <Progress.Label></Progress.Label>
              </Progress.Section>
            </Progress.Root>
          </div>
        </Stack>
      </Group>
    </Paper>
  );
}
